// @section 1 MSAL Configuration (Atlas)
// @subsection 1.1 Azure AD / Entra ID — reuses the OptiqOS app registration

import { type Configuration, LogLevel, BrowserCacheLocation } from "@azure/msal-browser";

const clientId = "edeaeb9c-02ff-4b91-ab18-67d0916979f2";
const tenantId = "6b66e125-8a0c-4f71-b464-bd90ebe66cf1";
const authority = `https://login.microsoftonline.com/${tenantId}`;
const origin = window.location.origin;

export const msalConfig = {
  auth: {
    clientId,
    authority,
    redirectUri: origin || "/",
    postLogoutRedirectUri: "/",
    // Must be false for SPAs: with auth-code flow, acquireTokenSilent uses a
    // hidden iframe. When true, MSAL navigates that iframe back to the login-
    // request URL, reloading the whole app inside the iframe so the silent
    // token call times out — every API request then goes out with no bearer
    // token and the OptiqOS API + Bridge both 401.
    navigateToLoginRequestUrl: false,
  },
  cache: { cacheLocation: "localStorage" as BrowserCacheLocation },
  system: {
    loggerOptions: { logLevel: LogLevel.Warning, piiLoggingEnabled: false },
    allowNativeBroker: false,
    iframeHashTimeout: 3000,
  },
} satisfies Record<string, unknown> as unknown as Configuration;

export const loginRequest = { scopes: ["openid", "profile", "email"] };
